import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sbe-sbe-service-lib',
  template: `
    <p>
      sbe-service-lib works!
    </p>
  `,
  styles: []
})
export class SbeServiceLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
